module.exports = __webpack_public_path__ + "img/conimg2-05.31631aaf.png";